export default {
  "content": "<path d=\"M5 19h14v-3h2v4a1 1 0 01-1 1H4a1 1 0 01-1-1v-4h2v3z\" fill=\"#7B61FF\"/><path d=\"M12 3a1 1 0 01.707.293l4.5 4.5-1.414 1.414L13 6.414V16.5h-2V6.414L8.207 9.207 6.793 7.793l4.5-4.5.073-.066A1 1 0 0112 3z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};